export default __webpack_public_path__ + "static/media/b2bCompany.c346e3a8.png";